import { render, staticRenderFns } from "./new-driver-form.vue?vue&type=template&id=7bce71e0&scoped=true&"
import script from "./new-driver-form.vue?vue&type=script&lang=js&"
export * from "./new-driver-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bce71e0",
  null
  
)

export default component.exports